import React from 'react'
import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'

const size = 50

const StButton = styled.div`
  position: absolute;
  top: -15px;
  right: -15px;
  width: ${size}px;
  height: ${size}px;
  > .btn-bg {
    position: absolute;
    display: block;
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
      0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color),
      0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
      var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    width: ${size}px;
    height: ${size}px;
    border-radius: ${size}px;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    svg {
    }
  }
`

const Button = () => {
  return (
    <StButton>
      <animated.div className="btn-bg">
        <svg
          className="animate-spin"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 70.21 70.25"
          width={size - 26}
          height={size - 26}>
          <title>Loading</title>
          <path d="M67.14,20.69a3.5,3.5,0,0,0-6.38,2.87A28.3,28.3,0,0,1,55,55a28.12,28.12,0,1,1-6.18-44.45A3.49,3.49,0,0,0,50.73,17l.37,0,6.75-.71.08,0a4.1,4.1,0,0,0,.48-.1l.22-.06.38-.17.26-.13a3.06,3.06,0,0,0,.29-.21,2,2,0,0,0,.27-.22l.12-.09a.71.71,0,0,0,.1-.14,2.48,2.48,0,0,0,.25-.3c.06-.08.11-.16.16-.24s.13-.23.19-.36a2.44,2.44,0,0,0,.1-.24,2.77,2.77,0,0,0,.12-.41c0-.08,0-.15.05-.23a3.42,3.42,0,0,0,0-.45v-.23a2.09,2.09,0,0,0,0-.25l-.71-6.74a3.5,3.5,0,0,0-6.86-.53A35.13,35.13,0,0,0,10.27,60,35.13,35.13,0,0,0,60,60,35.31,35.31,0,0,0,67.14,20.69Z" />
        </svg>
      </animated.div>
    </StButton>
  )
}

export default Button
